module.exports = __webpack_public_path__ + "img/finland-genitourinary-diseases-male.3ad6685a.png";